export enum PropertyOwnershipDocument {
  HEALTH_CARE_CARD = 'CARTEIRA_DE_POSTO_DE_SAÚDE',
  IPTU = 'IPTU',
  SCHOOL_ENROLLMENT = 'MATRÍCULA_ESCOLAR_DE_FAMILIARES',
  WATER_OR_LIGHT_BILL = 'RECIBO_OU_CONTA_DE_ÁGUA_OU_LUZ',
  PROPERTY_REGISTRATION = 'MATRICULA_IMOVEL',
}